import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import SegmentRoute from "@/pages/SegmentRoute";

export const Route = createFileRoute("/agente-ia-academia")({
  head: () => buildHead({
    title: SEGMENT_BY_SLUG["agente-ia-academia"]!.metaTitle,
    description: SEGMENT_BY_SLUG["agente-ia-academia"]!.metaDescription,
    path: "/agente-ia-academia",
  }),
  component: () => <SegmentRoute slug="agente-ia-academia" />,
});
